import styled from 'styled-components';

export const TextContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 260px;
  white-space: nowrap;
`;
